// components/TotalCard.js

import React from 'react';

const TotalCard = ({ title, amount, highlight, onClick, isNegative }) => {
  let backgroundColor = '#f0f0f0';
  if (highlight === 'highlight') {
    backgroundColor = '#f5c542';
  } else if (highlight === 'secondary') {
    backgroundColor = '#d0e0e3';
  } else if (isNegative) {
    backgroundColor = '#ff6b6b'; // Red background for negative amounts
  }

  const cardStyle = {
    backgroundColor,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    padding: '1rem',
    marginBottom: '1rem',
  };

  const titleStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333',
  };

  const amountStyle = {
    textAlign: 'center',
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#333',
  };

  return (
    <div style={cardStyle} onClick={onClick}>
      <div style={titleStyle}>
        {title}
      </div>
      <div style={amountStyle}>
        ${amount}
      </div>
    </div>
  );
};

export default TotalCard;
